import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { Priority, PrioritySingleResponse, StorePriorityRequest } from '@lib/api/models/priorities';
import { RegionService } from '@lib/region/region.service';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';

@Component({
    selector: 'app-prompt-region-priorities-status-change-dialog',
    imports: [ComponentsModule, ErrorPanelComponent],
    templateUrl: './prompt-region-priorities-status-change-dialog.component.html',
    standalone: true,
    styleUrl: './prompt-region-priorities-status-change-dialog.component.scss'
})
export class PromptRegionPrioritiesStatusChangeDialogComponent {
  protected readonly dialogRef = inject<DialogRef>(DialogRef);
    private readonly _regionService = inject(RegionService);
    private readonly _snackBar = inject(SnackBarService);
    protected readonly priority = inject<Priority>(DIALOG_DATA);

    updatePriorityRequest = new SendableRequest<PrioritySingleResponse, StorePriorityRequest>({
        request: (payload) => this._regionService.updatePriority(this.priority.id, payload!),
        onSuccess: () => {
            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Priority status changed successfully',
                actions: [
                    { id: 'undo', label: 'OK'}
                ]
            });

            this.dialogRef.close();
        },
        onError: () => {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Priority failed to change status',
                actions: [
                    { id: 'undo', label: 'OK'}
                ]
            });
        }
    });

    update(){
        this.updatePriorityRequest.send(this.priority);
    }

    public static show(dialog: DialogService, data: Priority) {
        return dialog.openDialog<DialogRef, Priority>(PromptRegionPrioritiesStatusChangeDialogComponent, {
                data
            }
        );
    }

}
